import { useDisclosure } from "@mantine/hooks";
import { useParams } from "react-router-dom";
import ManagementSearch from "src/components/pages/Management/ManagementSearch/ManagementSearch";
import ManagementTable from "src/components/pages/Management/ManagementTable/ManagementTable";
import AdminsListModal from "src/components/pages/Management/Organization/AdminsListModal/AdminsListModal";
import useRestricted from "src/components/pages/Management/useRestricted";
import Breadcrumbs from "src/components/shared/Breadcrumbs/Breadcrumbs";
import { useGetApi } from "src/hooks";
import { useSelector } from "src/redux/hooks";
import { ButtonsWrapper, PageContainer } from "src/styled";

import { type IOrganiozation } from "./Organizations.types";

const mapOrgs = (data: any) => {
  let list: IOrganiozation[] = [];
  if (data?.data?.content?.list) {
    list = data.data.content.list.map((el: IOrganiozation) => ({
      ...el,
      active: el.active ? "Yes" : null,
    }));
  }
  return { ...data?.data?.content, list };
};

const Organizations = () => {
  const [opened, { close }] = useDisclosure(false);
  const { clid } = useParams();
  const { isRestrictedToYacht, isRestrictedToOrg } = useSelector(
    state => state.permsSlice,
  );
  useRestricted([isRestrictedToYacht, isRestrictedToOrg]);

  const requestBody = { _sect: "_clients", _client: clid };

  const { data, isLoading, refetch } = useGetApi({
    request: "get-management",
    body: requestBody,
    mapper: mapOrgs,
  });

  return (
    <PageContainer>
      <AdminsListModal opened={opened} close={close} />
      <Breadcrumbs border={false}>
        <ButtonsWrapper>
          <ManagementSearch
            section="_organizations"
            refetch={refetch}
            currentRequestParams={requestBody}
          />
          {/* DO NOT REMOVE- waiting for implementation */}
          {/* <Button variant="outline" onClick={open}> */}
          {/*  Admins */}
          {/* </Button> */}
        </ButtonsWrapper>
      </Breadcrumbs>
      <ManagementTable
        section="_organizations"
        data={data?.list ?? []}
        loading={isLoading}
      />
    </PageContainer>
  );
};

export default Organizations;
